import React, { useState } from "react";
import { Button } from "@mui/material";
import { motion } from "framer-motion";
import { signInWithEmailAndPassword } from "firebase/auth";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import StyleSignin from "./signin.module.css";
import SigninImg from "../../Ui/signin.jpg";
import PatientDash from "../Patients/patientdash";
import { TextField } from "@mui/material";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";

const Signin = () => {
  const [patientData, setPatientData] = useState({
    name: "",
    patientid: "",
    email: "",
    password: "",
  });
  const [adminData, setAdminData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  const InputHandler = (e) => {
    setPatientData({ ...patientData, [e.target.name]: e.target.value });
  };
  const AdminInputHandler = (e) => {
    setAdminData({ ...adminData, [e.target.name]: e.target.value });
  };

  const submitHandler = async (e) => {
  e.preventDefault();

  const email = patientData.email.trim();
  const password = patientData.password.trim();
  const name = patientData.name;

  if (!email || !password) {
    alert("Email and Password are required.");
    return;
  }

  try {
    console.log("Attempting sign-in with:", email, password);
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    console.log("User signed in:", user);
    navigate("/", { state: { name: name } });
  } catch (error) {
    console.error("Firebase Auth Error:", error.code, error.message);
    alert("Sign-in failed: " + error.message);
  }
};


  const handleAdminLogin = (e) => {
    e.preventDefault();

    const { email, password, name } = adminData;

    const adminEmail = "admin@gmail.com";
    const adminPassword = "admin123";
    const adminName = "Admin";

    if (
      email === adminEmail &&
      password === adminPassword &&
      name === adminName
    ) {
      navigate("/admin/*/dashboard");
    } else {
      alert("Invalid Admin Credentials");
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className={StyleSignin.signincontainer}>
        <div className={StyleSignin.formimg}>
          <div>
            <motion.h1
              initial={{ x: -100 }}
              animate={{ x: [70, 0] }}
              transition={{ duration: "1" }}
              whileInView="visible"
            >
              Patient Sign In
            </motion.h1>
            <form className={StyleSignin.form} onSubmit={submitHandler}>
              {/* <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                name="name"
                label="Patient Name"
                type="text"
                fullWidth
                variant="standard"
                value={patientData.name}
                onChange={InputHandler}
              /> */}
              {/* <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                name="patientid"
                label="Patient Id"
                type="text"
                fullWidth
                variant="standard"
                value={patientData.patientid}
                onChange={InputHandler}
              /> */}
              <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                name="email"
                label="Email Address"
                type="email"
                variant="standard"
                value={patientData.email}
                onChange={InputHandler}
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                name="password"
                label="Password"
                type="password"
                fullWidth
                variant="standard"
                value={patientData.password}
                onChange={InputHandler}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "5rem",
                }}
              >
                <div className={StyleSignin.button}>
                  <Link to="/">
                    <Button variant="outlined" type="button">
                      Back to Home
                    </Button>
                  </Link>
                </div>
                <div className={StyleSignin.button}>
                  <Button variant="contained" type="submit">
                    Sign in
                  </Button>
                </div>
              </div>

              <div className={StyleSignin.button}>
                <Button
                  variant="contained"
                  type="button"
                  fullWidth
                  onClick={handleClickOpen}
                >
                  Sign in As Admin
                </Button>
              </div>

              <Dialog open={open} onClose={handleClose}>
                <form onSubmit={handleAdminLogin}>
                  <DialogTitle>Admin Dashboard Sign In</DialogTitle>
                  <DialogContent>
                    <TextField
                      required
                      margin="dense"
                      name="name"
                      label="User Name"
                      fullWidth
                      variant="standard"
                      value={adminData.name}
                      onChange={AdminInputHandler}
                    />
                    <TextField
                      required
                      margin="dense"
                      name="email"
                      label="Email Address"
                      type="email"
                      fullWidth
                      variant="standard"
                      value={adminData.email}
                      onChange={AdminInputHandler}
                    />
                    <TextField
                      required
                      margin="dense"
                      name="password"
                      label="Password"
                      type="password"
                      fullWidth
                      variant="standard"
                      value={adminData.password}
                      onChange={AdminInputHandler}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit">Sign In</Button>
                  </DialogActions>
                </form>
              </Dialog>
            </form>
            <div>does not have an account?
              <Link to="/login" style={{ textDecoration: "none" }}>
                    Login
                  </Link> now
               </div>
          </div>
          <div className={StyleSignin.img}>
            <img
              src={SigninImg}
              alt="signinimg"
              style={{ height: "28rem", width: "27rem" }}
            ></img>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signin;
